import { ConclusionKeys, FindingAreasEnum, QuestionnaireFlowType, getFindingAreaDisplayText, zodQuestionTypes } from "../surveyStatusSchemas";


const questionnaireNRD: QuestionnaireFlowType = {
    id: FindingAreasEnum.NonResidentDirectors,
    name: getFindingAreaDisplayText(FindingAreasEnum.NonResidentDirectors),
    questions: [
        {
            id: `${FindingAreasEnum.NonResidentDirectors}:Q1`,
            text: "Do you have directors (including non-executive directors) who are resident outside of the UK?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.NonResidentDirectors}:Q2`,
                no: ConclusionKeys.Green
            },
        },
        {
            id: `${FindingAreasEnum.NonResidentDirectors}:Q2`,
            text: "Do these directors spend workdays in the UK?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.NonResidentDirectors}:Q3`,
                no: ConclusionKeys.Green
            },
        },
        {
            id: `${FindingAreasEnum.NonResidentDirectors}:Q3`,
            text: "Do these directors receive specific remuneration in respect of their UK directorship?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: `${FindingAreasEnum.NonResidentDirectors}:Q4A`,
                no: `${FindingAreasEnum.NonResidentDirectors}:Q4B`,
            },
        },
        {
            id: `${FindingAreasEnum.NonResidentDirectors}:Q4A`,
            text: "Is this remuneration subject to income tax (and NIC where relevant) via UK PAYE?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: ConclusionKeys.Green,
                no: ConclusionKeys.Red
            },
        },
        {
            id: `${FindingAreasEnum.NonResidentDirectors}:Q4B`,
            text: "Is any remuneration in respect of directors subject to income tax (and NIC where relevant) via UK PAYE?",
            type: zodQuestionTypes.enum.YesNo,
            flow: {
                yes: ConclusionKeys.Amber,
                no: ConclusionKeys.Red
            },
        },
    ]
}

export default questionnaireNRD;